import { useEffect, useRef, useState } from 'react'
import AiOption from '../AiOption'
import { Editor } from '@tinymce/tinymce-react';
import RfpDrag from './RfpDrag';
import Toast from 'components/common/Toast';

const RfpInnerBox = ({ data: dataObj, index, setItemData, removeItem, dragItem }: any) => {
    const [isEditable, setIsEditable] = useState(false);
    const [data, setData] = useState(dataObj.content || '')
    const [isChecked, setIsChecked] = useState(dataObj?.showLabel || false);

    useEffect(() => {
        if (dataObj?.updatedTime) {
            setData(dataObj.content)
        }
    }, [dataObj?.updatedTime])

    const editorRef: any = useRef(null);

    const handleEditable = () => {
        setIsEditable(true);
    }

    const handleBlur = (e:any) => {
        // console.log('data =>', e.target.getContent());
        setData(e.target.getContent())
        setItemData({ index, content: e.target.getContent(), showLabel: isChecked })
        setIsEditable(false);
    }

    // const handleEditorChange = (e: any) => {
    //     setData(e.target.getContent())
    //     setItemData({ index, content: e.target.getContent(), showLabel: isChecked })
    // };

    const handleCheckboxChange = (isChecked: boolean) => {
        setIsChecked(isChecked);
        setItemData({ index, content: data, showLabel: isChecked })
    };

    const remove = () => {
        removeItem({ index })
    }

    const drag = (position: string) => {
        dragItem({ index, position })
    }

    const filePickerCallback = (callback: any, value: any, meta: any) => {
        const input: any = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.onchange = function () {
            const file = input.files[0];

            const maxSizeInMB = 1;
            const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

            if (file.size > maxSizeInBytes) {
                Toast.warning('Maximum File Size', 'File size must not exceed 1 MB')
                return;
            }

            const reader = new FileReader();
            reader.onload = function (e: any) {
                // Pass the base64 data to the callback
                callback(e.target.result, {
                    alt: file.name, // Provide alt text for the image
                    width: '300', // Set default width
                    height: '200'
                });
            };
            reader.readAsDataURL(file);
        };
        input.click();
    };

    const setEditorTextFromLLM = (text: string) => {
        setData(text)
        setItemData({ index, content: text, showLabel: isChecked })
    }

    // useEffect(() => {
    //     if (editorRef.current) {
    //         editorRef.current.focus();
    //     }
    // }, [editorRef.current]);

    return (
        <>
            <div className="border border-[#F0F0F0] bg-[#F9F9F9] rounded-sm flex mb-6">

                {/* Drag */}
                <RfpDrag dragItem={drag} />

                {/* Content */}
                <div className="w-full py-2 pr-2">
                    <div className="mb-2 flex justify-between items-center px-0.5">
                        <span className='font-interMedium text-sm text-[#344054]'>{dataObj?.title || 'No Title'}</span>
                        <div className='rfp-custom-checkbox'>
                            <input
                                type='checkbox'
                                name={'rfpName'}
                                checked={isChecked || false}
                                onChange={(e) => handleCheckboxChange(e.target.checked)}
                                style={{ width: '16px', height: '18px', cursor: 'pointer' }}
                            />
                            <label
                                className={`font-interMedium`}
                            >
                                <span className={`custom-checkbox-label font-interRegular text-sm text-[#667085] pl-1.5`}>Show label in draft</span>
                            </label>
                        </div>
                    </div>

                    <div className={`border border-[#D0D5DD] rounded-lg px-4 py-3 bg-[#fff] relative`}>
                        {
                            !isEditable &&
                            <>
                                {
                                    (dataObj?.title != 'Event Name' && dataObj?.title != 'Event Details' && dataObj?.title != 'Call to Action' && dataObj?.title != 'Event Date & Location') &&
                                    <AiOption editorText={data} setEditorTextFromLLM={setEditorTextFromLLM} removeItem={remove} />
                                }

                                <div
                                    onClick={handleEditable}
                                    contentEditable={isEditable}
                                    suppressContentEditableWarning={true}
                                    onBlur={handleBlur}
                                    className={`${isEditable ? "text-orange-500" : ""} pr-14 no-css min-h-5 cursor-pointer`}
                                    dangerouslySetInnerHTML={{ __html: data }}
                                >
                                </div>
                            </>
                        }
                        {
                            isEditable &&
                            <div className='relative'>
                                {/* <Editor
                                    // onInit={(editor) => (editorRef.current = editor)}
                                    onInit={(evt, editor) => {
                                        editorRef.current = editor;
                                        editor.focus(); // Set focus when the editor initializes
                                    }}
                                    initialValue={data}
                                    init={{
                                        menubar: false,
                                        body_class: 'custom-editor-styling',
                                        plugins: [
                                            'autolink', 'lists', 'link', 'image', 'preview',
                                            'anchor', 'code', 'fullscreen',
                                            'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount', 'table'
                                        ],
                                        toolbar: 'blocks | ' +
                                            'bold italic | alignleft aligncenter ' +
                                            'alignright alignjustify | bullist numlist outdent indent | ' +
                                            'link image media table',
                                        content_style: 'body { font-family:Inter,sans-serif; font-size:16px; }',
                                        automatic_uploads: true,
                                        file_picker_types: 'file image media',
                                        file_picker_callback: filePickerCallback,
                                    }}
                                    onChange={handleEditorChange}
                                    onBlur={handleBlur}
                                /> */}

                                <Editor
                                    onInit={(_evt, editor) => editorRef.current = editor}
                                    initialValue={data}
                                    init={{
                                        height: 350,
                                        menubar: false,
                                        plugins: [
                                            'autolink', 'lists', 'link', 'image', 'preview',
                                            'anchor', 'code', 'fullscreen',
                                            'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount',
                                            'textcolor', 'colorpicker', 'fontfamily', 'fontsize', // Added fontsize plugin
                                        ],
                                        toolbar: 'undo redo | blocks | ' +
                                            'bold italic underline | forecolor | fontfamily fontsize | alignleft aligncenter ' +
                                            'alignright alignjustify | lineheight | bullist numlist outdent indent | ' +
                                            'link image table',
                                        content_style: 'body { font-family: Inter, sans-serif; font-size: 16px; } * {margin: 5px 5px}',
                                        automatic_uploads: true,
                                        file_picker_types: 'file image media',
                                        file_picker_callback: filePickerCallback,
                                    }}
                                    //  onInput={handleEditorChange}
                                    onBlur={handleBlur}
                                />
                            </div>
                        }

                        {/* plugins: 'lineheight',
    toolbar: 'lineheightselect'  */}

                    </div>
                </div>

            </div>
        </>
    )
}

export default RfpInnerBox